import { Box, Stack, Typography, lighten, useTheme } from "@mui/material";

interface AdaListItemProps {
  name: string;
  value: string;
  variant: "blue" | "orange";
}
export function AdaListItem(props: AdaListItemProps) {
  const theme = useTheme();
  const tagColor =
    props.variant === "blue"
      ? theme.palette.primary.main
      : theme.palette.warning.main;

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Box>
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={"0.9rem"}
          fontWeight={"500"}
        >
          {props.name}
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor: lighten(tagColor, 0.9),
          padding: "2px 4px",
          borderRadius: "4px",
          border: `1px solid ${tagColor}`,
        }}
      >
        <Typography
          variant="body1"
          fontSize={"0.9rem"}
          fontWeight={"600"}
          color={tagColor}
        >
          {props.value}
        </Typography>
      </Box>
    </Stack>
  );
}

interface InventoryTagProps {
  value: string;
}
export function InventoryTag(props: InventoryTagProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        fontSize: "12px",
        fontWeight: 500,
        color: theme.palette.common.white,
        padding: "4px 12px",
        borderRadius: "16px",
      }}
    >
      {props.value}
    </Box>
  );
}
